import { authManager } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

import { pathWithBasename } from 'utils/pathWithBasename';

type RemoteEnv = 'local' | 'stag' | 'prod';

type Remote = {
  url: string;
  loadPromise: Promise<boolean> | null;
};

const remoteUrls: Record<RemoteEnv, string> = {
  local: 'http://localhost:4201',
  stag: 'https://bi-mfe.stag.dixa.io',
  prod: 'https://bi-mfe.dixa.io',
};

/**
 * The environment. Defaults to either `stag` or `prod` depending on the current
 * root Dixa environment. Assign it to `local` if you need to use a local
 * instance of the Miuros applications.
 */
//const env: RemoteEnv = 'local';
const env: RemoteEnv = config.environment === 'prod' ? 'prod' : 'stag';

const remote: Remote = {
  url: `${remoteUrls[env]}/remoteEntry.mjs`,
  loadPromise: null,
};

const getCurrentToken = async () => {
  const authData = await authManager.getAuthData();
  return authData?.access_token;
};

const doLoad = async (): Promise<boolean> => {
  try {
    // eslint-disable-next-line no-unsanitized/method
    const container = await import(/* @vite-ignore */ remote.url);

    // The remote bundles its own dependencies and shares nothing with the
    // host, so it initializes on an empty share scope.
    await container.init({});

    const moduleFactory = await container.get('./App');
    const module = await moduleFactory();

    const rootUrl = pathWithBasename('/analytics/dashboard/insights/');
    // The advanced-insights base URL is resolved from the current backend domain in
    // lib-shared-backend-config (like every other agent-interface call).
    module.bootstrap(
      env,
      rootUrl,
      getCurrentToken,
      config.url.advancedInsights,
    );
  } catch {
    return false;
  }

  return true;
};

export const loadIntelligenceRemote = (): Promise<boolean> => {
  if (!remote.loadPromise) {
    remote.loadPromise = doLoad();
  }

  return <Promise<boolean>>remote.loadPromise;
};
